module.exports = __webpack_public_path__ + "static/img/5723_phase_function_Paper_Points.8b12c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5723_phase_function_Paper_Points.png
// module id = 89z9
// module chunks = 0